import React, {Fragment} from 'react';
import {Button, Grid, Icon, TextArea} from 'semantic-ui-react';
import {injectIntl, intlShape} from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import AutoSaveField from './abstract/AutoSaveField.jsx';
import OnBlurContentEditable from "../BasicFormFields/OnBlurContentEditable";
import OnBlurTextArea from "../BasicFormFields/OnBlurTextArea";

import {isNoU, parseContentEditable} from "../../../utils/DBUtils";

class AutoSaveContentEditable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.defaultValue,
            valueLength: isNoU(props.defaultValue) ? 0 : parseContentEditable(props.defaultValue).length,
            showWysiwyg: true
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // don't reset the current defaultValue when there are failed validations.
        if (nextProps.defaultValue !== this.props.defaultValue && isEmpty(nextProps.errors)) {
            this.setState({
                value: nextProps.defaultValue,
                valueLength: isNoU(nextProps.defaultValue) ? 0 : parseContentEditable(nextProps.defaultValue).length
            });
        }
    }

    getValueFromOnChange = (event) => {
        return event.target.value;
    };

    updateTextLength = (length) => {
        this.setState({valueLength: length});
    };

    switchMode = () => {
        // console.log(`this.state.showWysiwyg: ${this.state.showWysiwyg}`)
        this.setState({showWysiwyg: !this.state.showWysiwyg})
    }

    promptLink = () => {
        const selection = window.getSelection();
        const textWasSelected = selection.focusOffset !== selection.anchorOffset;

        if (textWasSelected) {
            const url = prompt('Enter a URL: ', 'http://');
            const title = selection.toString();

            if (!isEmpty(url) && !url.match(/^https?:\/\/$/)) {
                const link = `<a href=${encodeURI(url)} target="_blank" rel="noopener">${title}</a>`;
                document.execCommand('insertHTML', false, link);
            }
        }
    };

    onValueChange = (value, name) => {    
        this.setState({
            value:value
        });
        let doc = new DOMParser().parseFromString(value, 'text/html');

        // Content editable is inserting styles when making and merging paragraphs
        // this is a quick solution, ideally we merge all span text into the parent paragraph
        let withStyles = doc.querySelectorAll('span[style]');
        for (let span of withStyles) {
          span.removeAttribute('style');
        }

        let linkStyles = doc.querySelectorAll('a[style]');
        for ( let linkStyle of linkStyles  ) {
          linkStyle.removeAttribute('style');
        }

        let cleanValue = doc.querySelector('body').innerHTML;
        cleanValue = cleanValue.replaceAll("<p></p>", "")
        cleanValue = cleanValue.replaceAll("<div><br></div>", "<br>")
        cleanValue = cleanValue.replaceAll("<br>", "<br/>")
        cleanValue = cleanValue.replaceAll("&nbsp;", " ")
    
        this.props.onPersistValue(cleanValue, name);
    };

    render() {
        return (
            <Fragment>
                <div className="content-editable-field">
                    { (this.state.showWysiwyg) && 
                        <AutoSaveField control={OnBlurContentEditable}
                            id={this.props.name}
                            getValueFromOnChange={this.getValueFromOnChange}
                            placeholder={this.props && this.props.placeholderKey ? this.props.intl.formatMessage({id: this.props.placeholderKey}) : ""}
                            html={this.state.value}
                            maxLength={this.props.maxLength}
                            {...this.props}
                            onPersistValue={this.onValueChange}
                            getTextLengthCallback={this.updateTextLength}
                            hideHelperText={true}
                        />
                    }
                    { (!this.state.showWysiwyg) && 
                        <AutoSaveField control={OnBlurTextArea}
                            id={this.props.name}
                            getValueFromOnChange={this.getValueFromOnChange}
                            placeholder={this.props && this.props.placeholderKey ? this.props.intl.formatMessage({id: this.props.placeholderKey}) : ""}
                            html={this.state.value}
                            maxLength={this.props.maxLength}
                            {...this.props}
                            onPersistValue={this.onValueChange}
                            getTextLengthCallback={this.updateTextLength}
                            hideHelperText={true}
                        />
                    }
                    { (!this.props.disabled) && <div className="formatting-buttons" style={{position: "relative", paddingTop: "3px", marginTop: 0}}>
                        {/* we always need to include this button to the user can switch back */}
                        <Button onClick={() => {
                            this.switchMode();
                        }}>
                            <Icon name="code"/>
                        </Button>

                        { (this.state.showWysiwyg) &&
                            <span>
                                <Button onClick={() => {
                                    document.execCommand('bold');
                                }}>
                                    <Icon name="bold"/>
                                </Button>
                                <Button onClick={() => {
                                    document.execCommand('italic');
                                }}>
                                    <Icon name="italic"/>
                                </Button>
                                <Button onClick={() => {
                                    document.execCommand('underline');
                                }}>
                                    <Icon name="underline"/>
                                </Button>
                                <Button onClick={() => {
                                document.execCommand('insertOrderedList');
                                }}>
                                <Icon name="ordered list"/>
                                </Button>
                                <Button onClick={() => {
                                document.execCommand('insertUnorderedList');
                                }}>
                                <Icon name="unordered list"/>
                                </Button>
                                <Button onClick={() => {
                                    document.execCommand('strikethrough');
                                }}>
                                    <Icon name="strikethrough"/>
                                </Button>
                                <Button onClick={() => {
                                    document.execCommand('superscript');
                                }}>
                                    <Icon name="superscript"/>
                                </Button>
                                <Button onClick={() => {
                                    document.execCommand('subscript');
                                }}>
                                    <Icon name="subscript"/>
                                </Button>
                                <Button onClick={() => {
                                    this.promptLink()
                                }}>
                                    <Icon name="linkify"/>
                                </Button>
                                <Button onClick={() => {
                                    document.execCommand('unlink');
                                }}>
                                    <Icon name="unlinkify"/>
                                </Button>

                        </span>
                        
                        }
                    </div>
                    }
                    {/* the char count has to stay here since ContentEditable can't update on state changes
            to avoid cursor jumps, buttons moved in for easier styling since char count has to stay */}
                    {this.props.maxLength ?
                        <div className='char-count'>
                            {this.state.valueLength}/{this.props.maxLength}
                        </div>
                        : ""}
                    { this.props.helperText && <div style={{marginBottom: "6px", fontSize: "14px"}}>{this.props.helperText}</div>}
                </div>
                <div style={{clear: 'both'}}></div>
            </Fragment>
        );
    }
}

AutoSaveContentEditable.propTypes = {
    intl: intlShape.isRequired
};

export default injectIntl(AutoSaveContentEditable);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveContentEditable.jsx